import styled from 'styled-components';

export const PopupTitle = styled.h1`
  text-align: center;
  font-size: 26px;
  margin-top: 0px;
  margin-bottom: 15px;
  color: ${(props) => props.theme.primary};
`;
